import React from "react";
import style from './Sell.module.css'

const Sell = () =>{
    return(
        <div className={style.formContent}>
            <div className={style.layout}>
                <div className={style.infoPanel}>
                    <span className={style.infoEyebrow}>Vender con nosotros</span>
                    <h1 className={style.infoTitle}>Tu propiedad, en las mejores manos</h1>
                    <p className={style.infoText}>
                        En By Raíces trabajamos con transparencia, cercanía y conocimiento real del mercado.
                        Cada propiedad que sumamos es acompañada por un agente especializado que se
                        encarga de todo el proceso de comercialización de tu inmueble, de principio a fin.
                    </p>

                    <div className={style.infoValues}>
                        <div className={style.infoValueItem}>
                            <span className={style.infoValueIcon}>🤝</span>
                            <div>
                                <h3 className={style.infoValueTitle}>Acompañamiento personalizado</h3>
                                <p className={style.infoValueText}>Un agente especializado va a trabajar tu consulta y te va a contactar a la brevedad.</p>
                            </div>
                        </div>
                        <div className={style.infoValueItem}>
                            <span className={style.infoValueIcon}>📈</span>
                            <div>
                                <h3 className={style.infoValueTitle}>Conocimiento del mercado</h3>
                                <p className={style.infoValueText}>Tasamos con criterio real, basado en la zona y el estado de tu propiedad.</p>
                            </div>
                        </div>
                        <div className={style.infoValueItem}>
                            <span className={style.infoValueIcon}>⚖️</span>
                            <div>
                                <h3 className={style.infoValueTitle}>Respaldo profesional</h3>
                                <p className={style.infoValueText}>Todas las operaciones son intermediadas por corredores públicos matriculados.</p>
                            </div>
                        </div>
                    </div>
                </div>

             <div className={style.card}>
             <h2 className={style.title} >Vendé tu propiedad</h2>
             <p className={style.text}>Completá el formulario y nos pondremos contacto con vos para continuar con el proceso</p>

             <form className={style.mailForm} action="https://formsubmit.co/byraices@byraices.com" method="POST" >
                <label className={style.mailLabel} htmlFor="name">Nombre</label>
                <input className={style.inputText} type="text" name='name' id='name'/>

                <label className={style.mailLabel} htmlFor="email">Correo electronico</label>
                <input className={style.inputText} type="email" name='email' id='email' />

                <label className={style.mailLabel} htmlFor="email">Telefono</label>
                <input className={style.inputText} type="Text" name='Phone' id='Phone' />

                <label className={style.mailLabel} htmlFor="propertyType">Tipo de propiedad</label>
    <select className={style.inputText} name="propertyType" id="propertyType">
        <option value="departamento">Departamento</option>
        <option value="casa">Casa</option>
        <option value="ph">PH</option>
        <option value="local">Local</option>
        <option value="terrenos y lotes">Terrenos y lotes</option>
        <option value="campos y chacras">Campos y chacras</option>
        <option value="fondo de comercio">Fondo de comercio</option>
        <option value="cochera">Cochera</option>
        <option value="oficina">Oficina</option>
        <option value="galpon">Galpón</option>
        <option value="quinta">Quinta</option>
        <option value="otros">Otros</option>
    </select>

                <label className={style.mailLabel} htmlFor="coments">Comentarios</label>
                <textarea className={style.inputText} name="coments" id="coments" cols="30" rows="5"></textarea>

                <input className={style.btn} type="submit" value="Enviar"/>
                <input type="hidden" name="_next" value="https://byraices.com/"/>
                <input type="hidden" name="_captcha" value="false"/>
                {/* poner la url correcta */}
             </form>
        </div>
            </div>
        </div>
    );
};

export default Sell